import { Platform, PROSPECT_PHONE_TYPE, Counterpart, ConversationType, SessionType } from './db';

export enum CallMetricColumns {
  SESSION_ID = 'session_id',
  TEAM_ID = 'team_id',
  STARTED_AT = 'started_at',
  CALL_TYPE = 'call_type',
  IS_TRELLUS_TELEPHONY = 'is_trellus_telephony',
  IS_INBOUND = 'is_inbound',
  IS_AUTODIAL = 'is_autodial',
  PARALLEL_LINES = 'parallel_lines',
  CALL_DURATION = 'call_duration',
  CUSTOMER_DURATION = 'customer_duration',
  LIVE_DURATION = 'live_duration',
  CUSTOMER_JOINED_AT = 'customer_joined_at',
  CUSTOMER_LIVE_AT = 'customer_live_at',
  CUSTOMER_LIVE_KNOWN_AT = 'customer_live_known_at',
  FIRST_USER_JOINED_AT = 'first_user_joined_at',
  CUSTOMER_DROPPED_DURATION = 'customer_dropped_duration',
  AGENT_DROPPED_DURATION = 'agent_dropped_duration',
  HAS_CUSTOMER_VOICEMAIL = 'has_customer_voicemail',
  HAS_AGENT_VOICEMAIL = 'has_agent_voicemail',
  HAS_PRERECORDED_VOICEMAIL = 'has_prerecorded_voicemail',
  CUSTOMER_ENDED = 'customer_ended',
  CUSTOMER_AUDIO_UPLOADED = 'customer_audio_uploaded',
  CUSTOMER_TRANSCRIPT_UPLOADED = 'customer_transcript_uploaded',
}

export enum SessionV2Columns {
  SESSION_ID = 'session_id',
  TEAM_ID = 'team_id',
  BASE_PATH = 'base_path',
  STARTED_AT = 'started_at',
  CONVERSATION_TYPE = 'conversation_type',
  SESSION_TYPE = 'session_type',
  CUSTOMER_ADDRESS = 'customer_address',
  AGENT_ADDRESS = 'agent_address',
  ADDRESS_TYPE = 'address_type',
  RESOURCE_TYPE = 'resource_type',
  RESOURCE_ID = 'resource_id',

}


export enum ReviewStatusColumns {
  SESSION_ID = 'session_id',
  OPENING_USER_ID = 'opening_user_id',
  IS_OPEN = 'is_open',
  OPENED_AT = 'opened_at',
}

export enum CommentColumns {
  COMMENT_ID = 'comment_id',
  SESSION_ID = 'session_id',
  USER_ID = 'user_id',
  COMMENT = 'comment',
  CREATED_AT = 'created_at',
  START = 'start',
  END = 'end',
}

export enum SessionDetailsV2Columns {
  SESSION_ID = 'session_id',
  TEAM_ID = 'team_id',
  STARTED_AT = 'started_at',
  CADENCE = 'cadence',
  CADENCE_STEP = 'cadence_step',
  PROSPECT_LIST = 'prospect_list',
  COMPANY_PERSONA = 'company_persona',
  MARKET = 'market',
  LEAD_TYPE = 'lead_type',
}

export enum SESSION_METRICS_COLUMNS {
    SESSION_ID = 'session_id',
    IS_FINALIZED = 'is_finalized',
    HAS_COMMINGLED_MP3 = 'has_commingled_mp3',
    SCHEDULED_START = 'scheduled_start',
    CREATED_AT = 'created_at',
    USER_ID = 'user_id',
    TEAM_ID = 'team_id',
    EXTERNAL_ACCOUNT_ID = 'external_account_id',
    ACCOUNT_ID = 'account_id',
    USER_NAME = 'user_name',
    REP_PHONE_VALUE = 'rep_phone_value',
    REP_PHONE_IS_LOCAL = 'rep_phone_is_local',
    AUDIO_DURATION = 'audio_duration',
    PROSPECT_TRANSCRIPT_DURATION = 'prospect_transcript_duration',
    USER_DURATION = 'user_duration',
    CALL_DURATION = 'call_duration',
    INITIAL_RINGING_DURATION = 'initial_ringing_duration',
    NUM_WORDS_PROSPECT = 'num_words_prospect',
    NUM_WORDS_REP = 'num_words_rep',
    LANGUAGE = 'language',
    IS_USER_HANGUP = 'is_user_hangup',
    IS_AUTODIALER_CREATED = 'is_autodialer_created',
    IS_AUTODIALER_HANGUP = 'is_autodialer_hangup',
    IS_CONNECTED = 'is_connected',
    CAN_IMPROVE_EARLY_HANGUP = 'can_improve_early_hangup',
    CAN_IMPROVE_NAVIGATE_MENU = 'can_improve_navigate_menu',
    CONNECT_TIME = 'connect_time',
    CONNECT_IS_LIVE = 'connect_is_live',
    CONNECT_IS_RECORDING = 'connect_is_recording',
    IS_ANSWERED = 'is_answered',
    ANSWERED_TIME = 'answered_time',
    TARGET_DURATION = 'target_duration',
    GATEKEEPER_DURATION = 'gatekeeper_duration',
    VOICEMAIL_DURATION = 'voicemail_duration',
    TARGET_SPEECH = 'target_speech',
    LIVE_DURATION = 'live_duration',
    GATEKEEPER_SPEECH = 'gatekeeper_speech',
    REP_SPEECH_WITH_GATEKEEPER = 'rep_speech_with_gatekeeper',
    REP_SPEECH_WITH_TARGET = 'rep_speech_with_target',
    REP_SPEECH_DURING_VOICEMAIL_DURATION = 'rep_speech_during_voicemail_duration',
    LONGEST_MONOLOGUE_REP_TARGET = 'longest_monologue_rep_target',
    NUMBER_WORDS_REP_ALL_ELIGIBLE = 'number_words_rep_all_eligible',
    DURATION_REP_ALL_ELIGIBLE_SPEECH = 'duration_rep_all_eligible_speech',
    WORDS_PER_SECOND_REP_ALL_ELIGIBLE = 'words_per_second_rep_all_eligible',
    NUMBER_WORDS_TARGET_ELIGIBLE = 'number_words_target_eligible',
    DURATION_TARGET_ELIGIBLE_SPEECH = 'duration_target_eligible_speech',
    WORDS_PER_SECOND_TARGET_ELIGIBLE = 'words_per_second_target_eligible',
    NUMBER_WORDS_REP_TARGET_ELIGIBLE = 'number_words_rep_target_eligible',
    DURATION_REP_TARGET_ELIGIBLE_SPEECH = 'duration_rep_target_eligible_speech',
    WORDS_PER_SECOND_REP_TARGET_ELIGIBLE = 'words_per_second_rep_target_eligible',
    R_DENY_COUNT = 'r_deny_count',
    R_NAME_DENY_COUNT = 'r_name_deny_count',
    R_TITLE_DENY_COUNT = 'r_title_deny_count',
    R_TRANSFER_DENY_COUNT = 'r_transfer_deny_count',
    R_RESP_NOT_DECISION_MAKER_COUNT = 'r_resp_not_decision_maker_count',
    R_RESP_NOT_RELEVANT_COUNT = 'r_resp_not_relevant_count',
    R_CALL_DENY_COUNT = 'r_call_deny_count',
    R_EMAIL_DENY_COUNT = 'r_email_deny_count',
    R_DELAYED_DENY_COUNT = 'r_delayed_deny_count',
    R_MEETING_DENY_COUNT = 'r_meeting_deny_count',
    R_PRODUCT_NO_NEED_COUNT = 'r_product_no_need_count',
    R_PRODUCT_NO_BUDGET_COUNT = 'r_product_no_budget_count',
    R_COMPETITORS_USING_COUNT = 'r_competitors_using_count',
    C_ASKS_COUNT = 'c_asks_count',
    C_REFERRAL_ASK_COUNT = 'c_referral_ask_count',
    C_BUSINESS_ASK_COUNT = 'c_business_ask_count',
    C_RESP_CHECK_COUNT = 'c_resp_check_count',
    C_MEETING_OFFER_COUNT = 'c_meeting_offer_count',
    C_CALL_OFFER_COUNT = 'c_call_offer_count',
    C_EMAIL_OFFER_COUNT = 'c_email_offer_count',
    R_MEETING_CONFIRM = 'r_meeting_confirm',
    R_CALL_APPROVE = 'r_call_approve',
    R_EMAIL_APPROVE_COUNT = 'r_email_approve_count',
    R_EMAIL_APPROVE = 'r_email_approve',
    R_REFERRAL_PROVIDE = 'r_referral_provide',
    R_PRODUCT_INTERESTED_COUNT = 'r_product_interested_count',
    GEN_SUMMARY_TEXT = 'gen_summary_text',
    GEN_EMAIL_TEXT = 'gen_email_text',
    GEN_COACHING_TEXT = 'gen_coaching_text',
    STAGE = 'stage',
    STAGE_DISPOSITION = 'stage_disposition',
    TRELLUS_DISPOSITION = 'trellus_disposition',
    CUSTOM_DISPOSITION = 'custom_disposition',
    USER_DISPOSITION = 'user_disposition',
    USER_SENTIMENT = 'user_sentiment',
    USER_PURPOSE = 'user_purpose',
  
    PROSPECT_NAME = 'prospect_name',
    PROSPECT_PHONE_VALUE = 'prospect_phone_value',
    PROSPECT_TRANSCRIBED = 'prospect_transcribed',
    PROSPECT_RECORDED = 'prospect_recorded',
    PROSPECT_TRANSCRIPT_PERSISTED = 'prospect_transcript_persisted',
  
    PLATFORM = 'platform',
    BEST_COUNTERPART = 'best_counterpart',
    PRIOR_PHONE_USER_NUM_CALLS = 'prior_phone_user_num_calls',
    PRIOR_PHONE_USER_MAX_ANSWERED_DURATION = 'prior_phone_user_max_answered_duration',
    PRIOR_PHONE_USER_ELAPSED_SINCE_FIRST = 'prior_phone_user_elapsed_since_first',
    PRIOR_PHONE_USER_ELAPSED_SINCE_LAST = 'prior_phone_user_elapsed_since_last',
    PRIOR_PHONE_USER_IS_TEAM_FIRST = 'prior_phone_user_is_team_first',
    PRIOR_PHONE_TEAM_NOT_USER_NUM_CALLS = 'prior_phone_team_not_user_num_calls',
  
    NEXT_C_CALL = 'next_c_call',
    NEXT_C_CALL_BACK = 'next_c_call_back'
  }
  
export type SessionMetricColumnToType = {
  [SESSION_METRICS_COLUMNS.SESSION_ID]: string,
  [SESSION_METRICS_COLUMNS.IS_FINALIZED]?: boolean,
  [SESSION_METRICS_COLUMNS.HAS_COMMINGLED_MP3]?: boolean,
  [SESSION_METRICS_COLUMNS.SCHEDULED_START]?: string,
  [SESSION_METRICS_COLUMNS.CREATED_AT]?: string,
  [SESSION_METRICS_COLUMNS.USER_ID]?: string,
  [SESSION_METRICS_COLUMNS.TEAM_ID]?: string,
  [SESSION_METRICS_COLUMNS.EXTERNAL_ACCOUNT_ID]?: string,
  [SESSION_METRICS_COLUMNS.ACCOUNT_ID]?: string,
  [SESSION_METRICS_COLUMNS.USER_NAME]?: string,
  [SESSION_METRICS_COLUMNS.REP_PHONE_VALUE]?: string,
  [SESSION_METRICS_COLUMNS.REP_PHONE_IS_LOCAL]?: boolean,
  [SESSION_METRICS_COLUMNS.AUDIO_DURATION]?: number,
  [SESSION_METRICS_COLUMNS.PROSPECT_TRANSCRIPT_DURATION]?: number,
  [SESSION_METRICS_COLUMNS.USER_DURATION]?: number,
  [SESSION_METRICS_COLUMNS.CALL_DURATION]?: number,
  [SESSION_METRICS_COLUMNS.INITIAL_RINGING_DURATION]?: number,
  [SESSION_METRICS_COLUMNS.NUM_WORDS_PROSPECT]?: number,
  [SESSION_METRICS_COLUMNS.NUM_WORDS_REP]?: number,
  [SESSION_METRICS_COLUMNS.LANGUAGE]?: string,
  [SESSION_METRICS_COLUMNS.IS_USER_HANGUP]?: boolean,
  [SESSION_METRICS_COLUMNS.IS_AUTODIALER_CREATED]?: boolean,
  [SESSION_METRICS_COLUMNS.IS_AUTODIALER_HANGUP]?: boolean,  
  [SESSION_METRICS_COLUMNS.IS_CONNECTED]?: boolean,
  [SESSION_METRICS_COLUMNS.CAN_IMPROVE_EARLY_HANGUP]?: boolean,
  [SESSION_METRICS_COLUMNS.CAN_IMPROVE_NAVIGATE_MENU]?: boolean,
  [SESSION_METRICS_COLUMNS.CONNECT_TIME]?: number,
  [SESSION_METRICS_COLUMNS.CONNECT_IS_LIVE]?: boolean,
  [SESSION_METRICS_COLUMNS.CONNECT_IS_RECORDING]?: boolean,
  [SESSION_METRICS_COLUMNS.IS_ANSWERED]?: boolean,
  [SESSION_METRICS_COLUMNS.ANSWERED_TIME]?: number,
  [SESSION_METRICS_COLUMNS.TARGET_DURATION]?: number,
  [SESSION_METRICS_COLUMNS.GATEKEEPER_DURATION]?: number,
  [SESSION_METRICS_COLUMNS.VOICEMAIL_DURATION]?: number,
  [SESSION_METRICS_COLUMNS.TARGET_SPEECH]?: number,
  [SESSION_METRICS_COLUMNS.LIVE_DURATION]?: number,
  [SESSION_METRICS_COLUMNS.GATEKEEPER_SPEECH]?: number,
  [SESSION_METRICS_COLUMNS.REP_SPEECH_WITH_GATEKEEPER]?: number,
  [SESSION_METRICS_COLUMNS.REP_SPEECH_WITH_TARGET]?: number,
  [SESSION_METRICS_COLUMNS.REP_SPEECH_DURING_VOICEMAIL_DURATION]?: number,
  [SESSION_METRICS_COLUMNS.LONGEST_MONOLOGUE_REP_TARGET]?: number, 
  [SESSION_METRICS_COLUMNS.NUMBER_WORDS_REP_ALL_ELIGIBLE]?: number,  
  [SESSION_METRICS_COLUMNS.DURATION_REP_ALL_ELIGIBLE_SPEECH]?: number,
  [SESSION_METRICS_COLUMNS.WORDS_PER_SECOND_REP_ALL_ELIGIBLE]?: number,
  [SESSION_METRICS_COLUMNS.NUMBER_WORDS_TARGET_ELIGIBLE]?: number,
  [SESSION_METRICS_COLUMNS.DURATION_TARGET_ELIGIBLE_SPEECH]?: number,
  [SESSION_METRICS_COLUMNS.WORDS_PER_SECOND_TARGET_ELIGIBLE]?: number,
  [SESSION_METRICS_COLUMNS.NUMBER_WORDS_REP_TARGET_ELIGIBLE]?: number, 
  [SESSION_METRICS_COLUMNS.DURATION_REP_TARGET_ELIGIBLE_SPEECH]?: number,
  [SESSION_METRICS_COLUMNS.WORDS_PER_SECOND_REP_TARGET_ELIGIBLE]?: number,
  [SESSION_METRICS_COLUMNS.R_DENY_COUNT]?: number,
  [SESSION_METRICS_COLUMNS.R_NAME_DENY_COUNT]?: number,
  [SESSION_METRICS_COLUMNS.R_TITLE_DENY_COUNT]?: number,
  [SESSION_METRICS_COLUMNS.R_TRANSFER_DENY_COUNT]?: number,
  [SESSION_METRICS_COLUMNS.R_RESP_NOT_DECISION_MAKER_COUNT]?: number,
  [SESSION_METRICS_COLUMNS.R_RESP_NOT_RELEVANT_COUNT]?: number,
  [SESSION_METRICS_COLUMNS.R_CALL_DENY_COUNT]?: number,
  [SESSION_METRICS_COLUMNS.R_EMAIL_DENY_COUNT]?: number,
  [SESSION_METRICS_COLUMNS.R_DELAYED_DENY_COUNT]?: number,
  [SESSION_METRICS_COLUMNS.R_MEETING_DENY_COUNT]?: number,
  [SESSION_METRICS_COLUMNS.R_PRODUCT_NO_NEED_COUNT]?: number,
  [SESSION_METRICS_COLUMNS.R_PRODUCT_NO_BUDGET_COUNT]?: number,  
  [SESSION_METRICS_COLUMNS.R_COMPETITORS_USING_COUNT]?: number,
  [SESSION_METRICS_COLUMNS.C_ASKS_COUNT]?: number,
  [SESSION_METRICS_COLUMNS.C_REFERRAL_ASK_COUNT]?: number,
  [SESSION_METRICS_COLUMNS.C_BUSINESS_ASK_COUNT]?: number,
  [SESSION_METRICS_COLUMNS.C_RESP_CHECK_COUNT]?: number,
  [SESSION_METRICS_COLUMNS.C_MEETING_OFFER_COUNT]?: number,
  [SESSION_METRICS_COLUMNS.C_CALL_OFFER_COUNT]?: number, 
  [SESSION_METRICS_COLUMNS.C_EMAIL_OFFER_COUNT]?: number,
  [SESSION_METRICS_COLUMNS.R_MEETING_CONFIRM]?: boolean,
  [SESSION_METRICS_COLUMNS.R_CALL_APPROVE]?: boolean,
  [SESSION_METRICS_COLUMNS.R_EMAIL_APPROVE_COUNT]?: number,
  [SESSION_METRICS_COLUMNS.R_EMAIL_APPROVE]?: boolean,
  [SESSION_METRICS_COLUMNS.R_REFERRAL_PROVIDE]?: boolean,
  [SESSION_METRICS_COLUMNS.R_PRODUCT_INTERESTED_COUNT]?: number,
  [SESSION_METRICS_COLUMNS.GEN_SUMMARY_TEXT]?: string,
  [SESSION_METRICS_COLUMNS.GEN_EMAIL_TEXT]?: string,
  [SESSION_METRICS_COLUMNS.GEN_COACHING_TEXT]?: string,
  [SESSION_METRICS_COLUMNS.STAGE]?: string,
  [SESSION_METRICS_COLUMNS.STAGE_DISPOSITION]?: string,
  [SESSION_METRICS_COLUMNS.TRELLUS_DISPOSITION]?: string,
  [SESSION_METRICS_COLUMNS.CUSTOM_DISPOSITION]?: string,
  [SESSION_METRICS_COLUMNS.USER_DISPOSITION]?: string,
  [SESSION_METRICS_COLUMNS.USER_SENTIMENT]?: string,
  [SESSION_METRICS_COLUMNS.USER_PURPOSE]?: string,
  [SESSION_METRICS_COLUMNS.PROSPECT_NAME]?: string,
  [SESSION_METRICS_COLUMNS.PROSPECT_PHONE_VALUE]?: string,
  [SESSION_METRICS_COLUMNS.PROSPECT_TRANSCRIBED]?: boolean,
  [SESSION_METRICS_COLUMNS.PROSPECT_RECORDED]?: boolean, 
  [SESSION_METRICS_COLUMNS.PROSPECT_TRANSCRIPT_PERSISTED]?: boolean,
  [SESSION_METRICS_COLUMNS.PLATFORM]?: Platform,
  [SESSION_METRICS_COLUMNS.BEST_COUNTERPART]?: Counterpart,
  [SESSION_METRICS_COLUMNS.PRIOR_PHONE_USER_NUM_CALLS]?: number,
  [SESSION_METRICS_COLUMNS.PRIOR_PHONE_USER_MAX_ANSWERED_DURATION]?: number,
  [SESSION_METRICS_COLUMNS.PRIOR_PHONE_USER_ELAPSED_SINCE_FIRST]?: number,
  [SESSION_METRICS_COLUMNS.PRIOR_PHONE_USER_ELAPSED_SINCE_LAST]?: number,
  [SESSION_METRICS_COLUMNS.PRIOR_PHONE_USER_IS_TEAM_FIRST]?: boolean,
  [SESSION_METRICS_COLUMNS.PRIOR_PHONE_TEAM_NOT_USER_NUM_CALLS]?: number,
  [SESSION_METRICS_COLUMNS.NEXT_C_CALL]?: boolean,
  [SESSION_METRICS_COLUMNS.NEXT_C_CALL_BACK]?: boolean,
}

export enum PROSPECT_INFO_COLUMNS {
  SESSION_ID = 'session_id',
  USER_ID = 'user_id',
  SCHEDULED_START = 'scheduled_start',
  PLATFORM = 'platform',
  PLATFORM_TENANT_ID = 'platform_tenant_id',
  PLATFORM_PERSON_ID = 'platform_person_id',
  PLATFORM_COMPANY_ID = 'platform_company_id',
  PLATFORM_PERSON_URL = 'platform_person_url',
  PROSPECT_PHONE_VALUE = 'prospect_phone_value',
  PROSPECT_PHONE_TYPE = 'prospect_phone_type',
  XREF_PLATFORM = 'xref_platform',
  XREF_PERSON_ID = 'xref_person_id',
  XREF_COMPANY_ID = 'xref_company_id',
  XREF_PERSON_URL = 'xref_person_url',
  CADENCE = 'cadence',
  CADENCE_2 = 'cadence_2',
  CADENCE_3 = 'cadence_3',
  CADENCE_STEP = 'cadence_step',
  CADENCE_STEP_2 = 'cadence_step_2',
  CADENCE_STEP_3 = 'cadence_step_3',
  PROSPECT_NAME = 'prospect_name',
  PROSPECT_TITLE = 'prospect_title',
  PROSPECT_OCCUPATION = 'prospect_occupation',
  PROSPECT_SENIORITY = 'prospect_seniority',
  PROSPECT_LOCATION = 'prospect_location',
  PROSPECT_LINKEDIN = 'prospect_linkedin',
  PROSPECT_EMAIL = 'prospect_email',
  PROSPECT_PHONE_OTHER_1 = 'prospect_phone_other_1',
  PROSPECT_PHONE_OTHER_2 = 'prospect_phone_other_2',
  COMPANY_NAME = 'company_name',
  COMPANY_LINKEDIN = 'company_linkedin',
  COMPANY_URL = 'company_url',
  COMPANY_INDUSTRY = 'company_industry',
  COMPANY_INDUSTRY_2 = 'company_industry_2',
  COMPANY_INDUSTRY_3 = 'company_industry_3',
  COMPANY_SIZE_MIN = 'company_size_min',
  COMPANY_SIZE_MAX = 'company_size_max',
  COMPANY_PERSONA = 'company_persona',
  PROSPECT_LIST = 'prospect_list',
  PROSPECT_LIST_2 = 'prospect_list_2',
  PROSPECT_LIST_3 = 'prospect_list_3',
  MARKET = 'market',
  LEAD_TYPE = 'lead_type'
}


export type ProspectInfoColumnToType = {
  [PROSPECT_INFO_COLUMNS.SESSION_ID]: string,
  [PROSPECT_INFO_COLUMNS.USER_ID]?: string,
  [PROSPECT_INFO_COLUMNS.SCHEDULED_START]?: string,
  [PROSPECT_INFO_COLUMNS.PLATFORM]?: Platform,
  [PROSPECT_INFO_COLUMNS.PLATFORM_TENANT_ID]?: string,
  [PROSPECT_INFO_COLUMNS.PLATFORM_PERSON_ID]?: string,
  [PROSPECT_INFO_COLUMNS.PLATFORM_COMPANY_ID]?: string,
  [PROSPECT_INFO_COLUMNS.PLATFORM_PERSON_URL]?: string,
  [PROSPECT_INFO_COLUMNS.PROSPECT_PHONE_VALUE]?: string,
  [PROSPECT_INFO_COLUMNS.PROSPECT_PHONE_TYPE]?: PROSPECT_PHONE_TYPE,
  [PROSPECT_INFO_COLUMNS.XREF_PLATFORM]?: Platform,
  [PROSPECT_INFO_COLUMNS.XREF_PERSON_ID]?: string,
  [PROSPECT_INFO_COLUMNS.XREF_COMPANY_ID]?: string,
  [PROSPECT_INFO_COLUMNS.XREF_PERSON_URL]?: string,
  [PROSPECT_INFO_COLUMNS.CADENCE]?: string,
  [PROSPECT_INFO_COLUMNS.CADENCE_2]?: string,
  [PROSPECT_INFO_COLUMNS.CADENCE_3]?: string,
  [PROSPECT_INFO_COLUMNS.CADENCE_STEP]?: string,
  [PROSPECT_INFO_COLUMNS.CADENCE_STEP_2]?: string,
  [PROSPECT_INFO_COLUMNS.CADENCE_STEP_3]?: string,
  [PROSPECT_INFO_COLUMNS.PROSPECT_NAME]?: string,
  [PROSPECT_INFO_COLUMNS.PROSPECT_TITLE]?: string,
  [PROSPECT_INFO_COLUMNS.PROSPECT_OCCUPATION]?: string,
  [PROSPECT_INFO_COLUMNS.PROSPECT_SENIORITY]?: string,
  [PROSPECT_INFO_COLUMNS.PROSPECT_LOCATION]?: string,
  [PROSPECT_INFO_COLUMNS.PROSPECT_LINKEDIN]?: string,
  [PROSPECT_INFO_COLUMNS.PROSPECT_EMAIL]?: string,
  [PROSPECT_INFO_COLUMNS.PROSPECT_PHONE_OTHER_1]?: string,
  [PROSPECT_INFO_COLUMNS.PROSPECT_PHONE_OTHER_2]?: string,
  [PROSPECT_INFO_COLUMNS.COMPANY_NAME]?: string,
  [PROSPECT_INFO_COLUMNS.COMPANY_LINKEDIN]?: string,
  [PROSPECT_INFO_COLUMNS.COMPANY_URL]?: string,
  [PROSPECT_INFO_COLUMNS.COMPANY_INDUSTRY]?: string,
  [PROSPECT_INFO_COLUMNS.COMPANY_INDUSTRY_2]?: string,
  [PROSPECT_INFO_COLUMNS.COMPANY_INDUSTRY_3]?: string,
  [PROSPECT_INFO_COLUMNS.COMPANY_SIZE_MIN]?: number,
  [PROSPECT_INFO_COLUMNS.COMPANY_SIZE_MAX]?: number,
  [PROSPECT_INFO_COLUMNS.COMPANY_PERSONA]?: string,
  [PROSPECT_INFO_COLUMNS.PROSPECT_LIST]?: string,
  [PROSPECT_INFO_COLUMNS.PROSPECT_LIST_2]?: string,
  [PROSPECT_INFO_COLUMNS.PROSPECT_LIST_3]?: string,
  [PROSPECT_INFO_COLUMNS.MARKET]?: string,
  [PROSPECT_INFO_COLUMNS.LEAD_TYPE]?: string,
}

// Type for CallMetricColumns values
export type CallMetricColumnToType = {
  [CallMetricColumns.SESSION_ID]: string;
  [CallMetricColumns.TEAM_ID]: string;
  [CallMetricColumns.STARTED_AT]: Date;
  [CallMetricColumns.CALL_TYPE]: string;
  [CallMetricColumns.IS_TRELLUS_TELEPHONY]: boolean;
  [CallMetricColumns.IS_INBOUND]: boolean;
  [CallMetricColumns.IS_AUTODIAL]: boolean;
  [CallMetricColumns.PARALLEL_LINES]: number;
  [CallMetricColumns.CALL_DURATION]: number;
  [CallMetricColumns.CUSTOMER_DURATION]: number;
  [CallMetricColumns.LIVE_DURATION]: number;
  [CallMetricColumns.CUSTOMER_JOINED_AT]: string;
  [CallMetricColumns.CUSTOMER_LIVE_AT]: string;
  [CallMetricColumns.CUSTOMER_LIVE_KNOWN_AT]: string;
  [CallMetricColumns.FIRST_USER_JOINED_AT]: string;
  [CallMetricColumns.CUSTOMER_DROPPED_DURATION]: number;
  [CallMetricColumns.AGENT_DROPPED_DURATION]: number;
  [CallMetricColumns.HAS_CUSTOMER_VOICEMAIL]: boolean;
  [CallMetricColumns.HAS_AGENT_VOICEMAIL]: boolean;
  [CallMetricColumns.HAS_PRERECORDED_VOICEMAIL]: boolean;
  [CallMetricColumns.CUSTOMER_ENDED]: boolean;
  [CallMetricColumns.CUSTOMER_AUDIO_UPLOADED]: boolean;
  [CallMetricColumns.CUSTOMER_TRANSCRIPT_UPLOADED]: boolean;
};

// Type for SessionV2Columns values
export type SessionV2ColumnToType = {
  [SessionV2Columns.SESSION_ID]: string;
  [SessionV2Columns.TEAM_ID]: string;
  [SessionV2Columns.BASE_PATH]: string;
  [SessionV2Columns.STARTED_AT]: Date;
  [SessionV2Columns.CONVERSATION_TYPE]: ConversationType;
  [SessionV2Columns.SESSION_TYPE]: SessionType;
  [SessionV2Columns.CUSTOMER_ADDRESS]: string;
  [SessionV2Columns.AGENT_ADDRESS]: string;
  [SessionV2Columns.ADDRESS_TYPE]: string;
  [SessionV2Columns.RESOURCE_TYPE]: string;
  [SessionV2Columns.RESOURCE_ID]: string;
};

// Type for ReviewStatusColumns values
export type ReviewStatusColumnToType = {
  [ReviewStatusColumns.SESSION_ID]: string;
  [ReviewStatusColumns.OPENING_USER_ID]: string;
  [ReviewStatusColumns.IS_OPEN]: boolean;
  [ReviewStatusColumns.OPENED_AT]: string;
};

// Type for CommentColumns values
export type CommentColumnToType = {
  [CommentColumns.COMMENT_ID]: string;
  [CommentColumns.SESSION_ID]: string;
  [CommentColumns.USER_ID]: string;
  [CommentColumns.COMMENT]: string;
  [CommentColumns.CREATED_AT]: string;
  [CommentColumns.START]: number;
  [CommentColumns.END]: number;
};

// Type for SessionDetailsV2Columns values
export type SessionDetailsV2ColumnToType = {
  [SessionDetailsV2Columns.SESSION_ID]: string;
  [SessionDetailsV2Columns.TEAM_ID]: string;
  [SessionDetailsV2Columns.STARTED_AT]: Date;
  [SessionDetailsV2Columns.CADENCE]: string;
  [SessionDetailsV2Columns.CADENCE_STEP]: string;
  [SessionDetailsV2Columns.PROSPECT_LIST]: string;
  [SessionDetailsV2Columns.COMPANY_PERSONA]: string;
  [SessionDetailsV2Columns.MARKET]: string;
  [SessionDetailsV2Columns.LEAD_TYPE]: string;
};


export enum CallbackRequestColumns {
  SESSION_ID = 'session_id',
  USER_ID = 'user_id',
  TEAM_ID = 'team_id',
  SCHEDULED_START = 'scheduled_start',
  CALLBACK_STATUS = 'callback_status',
  CALLBACK_TIMING = 'callback_timing',
  CALLBACK_REASONING = 'callback_reasoning'
}

export type CallbackRequestColumnToType = {
  [CallbackRequestColumns.SESSION_ID]: string;
  [CallbackRequestColumns.USER_ID]: string;
  [CallbackRequestColumns.TEAM_ID]: string;
  [CallbackRequestColumns.SCHEDULED_START]: Date;
  [CallbackRequestColumns.CALLBACK_STATUS]: string;
  [CallbackRequestColumns.CALLBACK_TIMING]: Date | null;
  [CallbackRequestColumns.CALLBACK_REASONING]: string;
}

export enum MessagingDataColumns {
  SESSION_ID = 'session_id',
  TEAM_ID = 'team_id',
  CUSTOMER_BODIES_STR = 'customer_bodies_str',
  CUSTOMER_TIMES_STR = 'customer_times_str',
  AGENT_BODIES_STR = 'agent_bodies_str',
  AGENT_TIMES_STR = 'agent_times_str',
  MAX_CUSTOMER_AT = 'max_customer_at'
}

export type MessagingDataColumnToType = {
  [MessagingDataColumns.SESSION_ID]: string;
  [MessagingDataColumns.TEAM_ID]: string;
  [MessagingDataColumns.CUSTOMER_BODIES_STR]: string;
  [MessagingDataColumns.CUSTOMER_TIMES_STR]: string;
  [MessagingDataColumns.AGENT_BODIES_STR]: string;
  [MessagingDataColumns.AGENT_TIMES_STR]: string;
  [MessagingDataColumns.MAX_CUSTOMER_AT]: Date | null;
}

export enum CustomMetricColumns {
  SESSION_ID = 'session_id',
  METRIC_0 = 'metric_0',
  METRIC_1 = 'metric_1',
  METRIC_2 = 'metric_2',
  METRIC_3 = 'metric_3',
  METRIC_4 = 'metric_4',
  METRIC_5 = 'metric_5',
  METRIC_6 = 'metric_6',
  METRIC_7 = 'metric_7',
  METRIC_8 = 'metric_8',
  METRIC_9 = 'metric_9',
  METRIC_10 = 'metric_10',
  METRIC_11 = 'metric_11',
  METRIC_12 = 'metric_12',
  METRIC_13 = 'metric_13',
  METRIC_14 = 'metric_14',
  METRIC_15 = 'metric_15',
  METRIC_16 = 'metric_16',
  METRIC_17 = 'metric_17',
  METRIC_18 = 'metric_18',
  METRIC_19 = 'metric_19',
  TEXT_0 = 'text_0',
  TEXT_1 = 'text_1',
  TEXT_2 = 'text_2',
  TEXT_3 = 'text_3',
  TEXT_4 = 'text_4',
}

export type CustomMetricColumnToType = {
  [CustomMetricColumns.SESSION_ID]: string;
  [CustomMetricColumns.METRIC_0]: number | null;
  [CustomMetricColumns.METRIC_1]: number | null;
  [CustomMetricColumns.METRIC_2]: number | null;
  [CustomMetricColumns.METRIC_3]: number | null;
  [CustomMetricColumns.METRIC_4]: number | null;
  [CustomMetricColumns.METRIC_5]: number | null;
  [CustomMetricColumns.METRIC_6]: number | null;
  [CustomMetricColumns.METRIC_7]: number | null;
  [CustomMetricColumns.METRIC_8]: number | null;
  [CustomMetricColumns.METRIC_9]: number | null;
  [CustomMetricColumns.METRIC_10]: number | null;
  [CustomMetricColumns.METRIC_11]: number | null;
  [CustomMetricColumns.METRIC_12]: number | null;
  [CustomMetricColumns.METRIC_13]: number | null;
  [CustomMetricColumns.METRIC_14]: number | null; 
  [CustomMetricColumns.METRIC_15]: number | null;
  [CustomMetricColumns.METRIC_16]: number | null;
  [CustomMetricColumns.METRIC_17]: number | null;
  [CustomMetricColumns.METRIC_18]: number | null;
  [CustomMetricColumns.METRIC_19]: number | null;
  [CustomMetricColumns.TEXT_0]: string | null;
  [CustomMetricColumns.TEXT_1]: string | null;
  [CustomMetricColumns.TEXT_2]: string | null;
  [CustomMetricColumns.TEXT_3]: string | null;
  [CustomMetricColumns.TEXT_4]: string | null;
}

export enum CustomDetailColumns {
  SESSION_ID = 'session_id',
  METRIC_TO_RAW_JSON_STR = 'metric_to_raw_json_str',
  METRIC_TO_TIME_JSON_STR = 'metric_to_time_json_str',
  METRIC_TO_EXPLANATION_JSON_STR = 'metric_to_explanation_json_str',
}

export type CustomDetailColumnToType = {
  [CustomDetailColumns.SESSION_ID]: string;
  [CustomDetailColumns.METRIC_TO_RAW_JSON_STR]: string | null;
  [CustomDetailColumns.METRIC_TO_TIME_JSON_STR]: string | null;
  [CustomDetailColumns.METRIC_TO_EXPLANATION_JSON_STR]: string | null;
}

export enum PersonV2Columns {
  TEAM_ID = 'team_id',
  PLATFORM_PERSON_ID = 'platform_person_id',
  PLATFORM = 'platform',
  PLATFORM_COMPANY_ID = 'platform_company_id',
  PLATFORM_PERSON_URL = 'platform_person_url',
  NAME = 'name',
  NAME_LOWER = 'name_lower',
  LAST_NAME_LOWER = 'last_name_lower',
  TITLE = 'title',
  OCCUPATION = 'occupation',
  SENIORITY = 'seniority',
  LOCATION = 'location',
  PERSON_LINKEDIN = 'person_linkedin',
}

export type PersonV2ColumnToType = {
  [PersonV2Columns.TEAM_ID]: string;
  [PersonV2Columns.PLATFORM_PERSON_ID]: string;
  [PersonV2Columns.PLATFORM]: string;
  [PersonV2Columns.PLATFORM_COMPANY_ID]: string | null;
  [PersonV2Columns.PLATFORM_PERSON_URL]: string | null;
  [PersonV2Columns.NAME]: string | null;
  [PersonV2Columns.NAME_LOWER]: string | null;
  [PersonV2Columns.LAST_NAME_LOWER]: string | null;
  [PersonV2Columns.TITLE]: string | null;
  [PersonV2Columns.OCCUPATION]: string | null;
  [PersonV2Columns.SENIORITY]: string | null;
  [PersonV2Columns.LOCATION]: string | null;
  [PersonV2Columns.PERSON_LINKEDIN]: string | null;
}

export enum CompanyColumns {  
  TEAM_ID = 'team_id',
  PLATFORM_COMPANY_ID = 'platform_company_id',
  PLATFORM = 'platform',
  NAME = 'name',
  NAME_LOWER = 'name_lower',
  DOMAIN = 'domain',
  COMPANY_URL = 'company_url',
  COMPANY_LINKEDIN = 'company_linkedin',
  COMPANY_SIZE = 'company_size',
  INDUSTRY_STR = 'industry_str',
}

export type CompanyColumnToType = {
  [CompanyColumns.TEAM_ID]: string;
  [CompanyColumns.PLATFORM_COMPANY_ID]: string;
  [CompanyColumns.PLATFORM]: string;
  [CompanyColumns.NAME]: string | null;
  [CompanyColumns.NAME_LOWER]: string | null;
  [CompanyColumns.DOMAIN]: string | null;
  [CompanyColumns.COMPANY_URL]: string | null;
  [CompanyColumns.COMPANY_LINKEDIN]: string | null;
  [CompanyColumns.COMPANY_SIZE]: string | null;
  [CompanyColumns.INDUSTRY_STR]: string | null;
}

export enum SessionAgentsColumns {
  SESSION_ID = 'session_id',
  TEAM_ID = 'team_id',
  AGENT_IDS_STR = 'agent_ids_str',
  AGENT_TYPES_STR = 'agent_types_str',
  JOINED_AT_STR = 'joined_at_str',
  LEFT_AT_STR = 'left_at_str',
  FIRST_USER_ID = 'first_user_id',
  CREATOR_AGENT_ID = 'creator_agent_id',
  CREATOR_AGENT_TYPE = 'creator_agent_type',
}

export type SessionAgentsColumnToType = {
  [SessionAgentsColumns.SESSION_ID]: string;
  [SessionAgentsColumns.TEAM_ID]: string;
  [SessionAgentsColumns.AGENT_IDS_STR]: string;
  [SessionAgentsColumns.AGENT_TYPES_STR]: string;
  [SessionAgentsColumns.JOINED_AT_STR]: string;
  [SessionAgentsColumns.LEFT_AT_STR]: string;
  [SessionAgentsColumns.FIRST_USER_ID]: string | null;
  [SessionAgentsColumns.CREATOR_AGENT_ID]: string | null;
  [SessionAgentsColumns.CREATOR_AGENT_TYPE]: string | null;
}


// Define a union of all column types
export type BackendColumns = 
| SESSION_METRICS_COLUMNS
| PROSPECT_INFO_COLUMNS
| CallMetricColumns
| SessionV2Columns
| ReviewStatusColumns
| CommentColumns
| SessionDetailsV2Columns
| CallbackRequestColumns
| MessagingDataColumns
| CustomMetricColumns
| CustomDetailColumns
| SessionAgentsColumns

// Create a complete type mapping that combines all column types to their value types
export type ColumnValueMap = 
& SessionMetricColumnToType
& ProspectInfoColumnToType
& CallMetricColumnToType
& SessionV2ColumnToType
& ReviewStatusColumnToType
& CommentColumnToType
& SessionDetailsV2ColumnToType
& CallbackRequestColumnToType
& MessagingDataColumnToType
& CustomMetricColumnToType
& CustomDetailColumnToType 
& SessionAgentsColumnToType
